<template>
    <div>
        <div class="banner1">
            <img src="../assets/img/banner5.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="left_bar">
                    <!-- <div class="title">技术支持</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YunWeiFuWu')">运维服务</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheMiYeWuFuWu')">涉密业务服务</a></li>
                    </ul> -->
                    <div class="title">产品与服务</div>
                    <ul>
                        <li><a href="javascript:void(0);" @click.stop="goTo('RuanJianChanPin')">软件产品</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YingJianChanPin')">硬件产品</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('ZhiNengShuiBiao')">智能水表</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('YunWeiFuWu')">运维服务</a></li>
                        <li><a href="javascript:void(0);" @click.stop="goTo('SheMiYeWuFuWu')">涉密业务服务</a></li>
                    </ul>
                </div>
                <div class="right_contnet">
                    <h2>{{ article.title }}</h2>
                    <div class="product_view">
                        <div class="main_content" v-html="article.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { JiShuZhiChi } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '技术支持',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            id: this.$route.query.id, //传入的id

            article: {
                title:'',
                datetime:'',
                content:''
            },
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.JiShuZhiChi_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        JiShuZhiChi_data(){ //文章分类显示
            JiShuZhiChi({
                id: this.id,
            }).then((res) => {
                console.log( res );
               
                this.article.title = res.rows[0].technicalTitle;
                this.article.datetime = res.rows[0].createDate;
                this.article.content = res.rows[0].technicalDetails;
            });
        },
    },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/JiShuZhiChiView.vue